import React from 'react';

import config from '../../config';
import {
  ADMIN_AUDIT_LOGS_PATH,
  ADMIN_FULLY_CONNECTED_PATH,
  ADMIN_GLUE_PATH,
  ADMIN_HOME_PATH,
  ADMIN_ORGANIZATION_PATHS,
  ADMIN_RAMP_PATH,
  ADMIN_USERS_PATH,
} from './adminPaths';

/**
 * Please note that depending on the page and condition checks, there
 * may be pages that SERVER INSTANCE admin can access as well, NOT JUST WANDB ADMINS ON SAAS.
 */
export const ADMIN_ROUTES_DATA = [
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'AdminUsage',
    },
    condition: config.ENVIRONMENT_IS_PRIVATE,
    exact: true,
    isPrivateRoute: true,
    path: ADMIN_AUDIT_LOGS_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/AuditLogs/AuditLogsPage')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'AdminOrganization',
    },
    isPrivateRoute: true,
    path: ADMIN_ORGANIZATION_PATHS,
    RouteComponent: React.lazy(
      () => import('../../wandb-admin/pages/OrganizationAdminPage')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'AdminUser',
    },
    isPrivateRoute: true,
    path: ADMIN_USERS_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/UsersAdminPage/UsersAdminPageRouter')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'AdminFullyConnected',
    },
    isPrivateRoute: true,
    path: ADMIN_FULLY_CONNECTED_PATH,
    RouteComponent: React.lazy(() => import('../../pages/GalleryAdmin')),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'AdminRamp',
    },
    isPrivateRoute: true,
    path: ADMIN_RAMP_PATH,
    RouteComponent: React.lazy(() => import('../../pages/Ramp/RampAdmin')),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'AdminGlue',
    },
    isPrivateRoute: true,
    path: ADMIN_GLUE_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'AdminHome',
    },
    isPrivateRoute: true,
    path: ADMIN_HOME_PATH,
    RouteComponent: React.lazy(
      () => import('../../wandb-admin/pages/HomeAdminPage')
    ),
  },
];
